<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useRouter } from 'vue-router';
import { useAlert } from 'dashboard/composables';

import SettingsPageLayout from 'dashboard/components-next/layout/SettingsPageLayout.vue';
import PermissionGroupForm from './components/PermissionGroupForm.vue';

const router = useRouter();
const store = useStore();
const { t } = useI18n();

const formRef = ref(null);
const uiFlags = useMapGetter('permissionGroups/getUIFlags');

const handleSubmit = async formState => {
  try {
    const group = await store.dispatch('permissionGroups/create', formState);
    useAlert(t('PERMISSION_GROUPS.CREATE.API.SUCCESS_MESSAGE'));
    formRef.value?.resetForm();
    router.push({
      name: 'permission_groups_edit',
      params: { id: group.id },
    });
  } catch (error) {
    useAlert(error?.message || t('PERMISSION_GROUPS.CREATE.API.ERROR_MESSAGE'));
  }
};

const handleCancel = () => {
  router.push({ name: 'permission_groups_index' });
};
</script>

<template>
  <SettingsPageLayout
    :title="$t('PERMISSION_GROUPS.CREATE.TITLE')"
    :description="$t('PERMISSION_GROUPS.CREATE.DESCRIPTION')"
    :back-url="{ name: 'permission_groups_index' }"
  >
    <template #body>
      <PermissionGroupForm
        ref="formRef"
        mode="CREATE"
        :is-loading="uiFlags.isCreating"
        @submit="handleSubmit"
        @cancel="handleCancel"
      />
    </template>
  </SettingsPageLayout>
</template>
